module.exports = __webpack_public_path__ + "img/greynailuxurygoodsm.61f7546b.webp";